import "./App.css";
import { useState, useEffect } from "react";
import Homepage from "./pages/Homepage/Homepage";
import SigninPages from "./pages/auth/Signin";
import SignupPages from "./pages/auth/SignUp";
import ProfilePage from "./pages/Profile/ProfilePages";
import SearchByLocation from "./pages/job/SearchByLocation";
import ApplyJob from "./pages/application/ApplyJob";
import SingleJob from "./pages/job/SingleJob";
import JobPage from "./pages/job/JobPage";
import EmployeePage from "./pages/Employer/EmployeePage";
import PostJob from "./pages/job/PostJob";
import EmployeeData from "./pages/employee/EmployeeData";
import Eja from "./pages/eja/Eja";
import EjaDetails from "./pages/eja/EjaDetails";
import JobFromEja from "./pages/job/JobFromEja";
import ApplicantList from "./pages/application/ApplicantList";
import TemplateCV from "./pages/cv/TemplateCV";
import Notification from "./pages/Notification";
import Quickjob from "./pages/job/Quickjob";
import ApplyJobForm from "./pages/ApplyJobForm"
import ApplyForAllowance from "./pages/application/ApplyForAllowance";
import GuarantorForm from "./pages/GuarantorForm";
import Blog from "./pages/Blog";
import Benefit from "./pages/benefit/Benefit";
import Blacklist from "./pages/blacklist/Blacklist";
import AboutUs from "./pages/about/AboutUs";
import Privacy from "./pages/privacy/PrivacyPage";
import TermAndConditions from "./pages/TermAndConditions";
import Offer from "./pages/job/Offer";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ApplicantResponse from "./pages/application/ApplicantResponse";
import ApplicantionStatus from "./pages/application/ApplicationStatus";
import EmployeeProfile from "./pages/employee/EmployeeProfile";
import Dashboard from "./pages/admin/Dashboard";
import MakeOffer from "./pages/job/MakeOffer";
import SearchByCategory from "./pages/job/SearchByCategory";
import VerifyToken from "./pages/auth/VerifyToken";
import Company from "./pages/Company";
import NotFound from "./component/notFound/NotFound";
import Candidate from "./pages/candidate";
import InterviewPeer from "./pages/interview/InterviewPeer";
import NewPassword from "./pages/auth/NewPassword";
import ViewCandidate from "./pages/candidate/ViewCandidate";
import Admin from "./Admin/Admin";
import Login from "./Admin/Login";
import Register from "./Admin/Register";



import JuniorAdminLogin from "./adminCreatedBySuperAdmin/JuniorAdminLogin";
import JuniorAdminDashboard from "./adminCreatedBySuperAdmin/JuniorAdminDashboard";
import JobNotificationRegister from "./pages/Subscription/JobNotificationRegister";
import AdminAccountantLogin from "./adminCreatedBySuperAdmin/AdminAccountantLogin";
import AdminAccountant1 from "./adminCreatedBySuperAdmin/AdminAccountant1";
import AdminAccountant2 from "./adminCreatedBySuperAdmin/AdminAccountant2";

import EmployeeDetails from "./pages/Employer/EmployeeDetails";
import GuarantorView from "./pages/Profile/GuarantoView";
import GuarantorFormNew from "./pages/Profile/GuarantorForm"
import DigitalIDCard from "./pages/Profile/DigitalIDCard";
import UserDetails from "./pages/Profile/UserDetails";
import RedirectionSignin from "./pages/auth/RedirectionSignIn";
import EmploymentOfferEditor from "./pages/Employer/EmploymentOfferEditor";
import JobEmployerGrid from "./pages/JobEmployerGrid";
import PersonalDetailsForm from "./pages/Profile/PersonalDetailsform";
import PermanentLetter from "./pages/Employer/PermanentLetter";
import JobSeekerDashboard from "./pages/Profile/renewDashboard/jobseekerDashboard";
import JobDashboard from "./pages/Employer/renewDashboard/EmployerDashboard";
import EmployerDashboard from "./pages/Employer/EmployerDashboard";
import AdminLogin from "./adminLatest/LatestAdminLogin";
import LatestAdminDashboard from "./adminLatest/LatestAdminDasboard";
import MarketerLogin from "./adminLatest/MarketerLogin";
import MarketerDashboard from "./adminLatest/MarketerDasboard";
import InvitationResponse from "./pages/application/InvitationResponse";
import JobsByIndustryPage from "./pages/job/JobsByIndustryPage";
import VerifyCallback from "./pages/VerifyCallback";
import AboutEmployerPage from "./component/AboutEmployerPage";
import GeneralStats from "./pages/GeneralStats";
import InterviewArticlePage from "./pages/Homepage/InterviewArticle";
import IndustryJobsPage from "./pages/job/IndustryjobPage";
function App() {
  const [showModal, setShowModal] = useState(!localStorage.getItem('ooshPin'));
   useEffect(() => {
    if (localStorage.getItem('ejobEmail') && !localStorage.getItem('ooshPin')) {
      setShowModal(true);
    }
  }, []);
  const router = createBrowserRouter([
   
    {
      path: "/",
      element: <Homepage />,
    },
   {
    path : "/invitation/respond",
     element : <InvitationResponse />
   },
    {
      path: "/login",
      element: <SigninPages/>,
    },
   
    {
      path: "/jobseekerdashboard",
      element: < JobSeekerDashboard />,
    },
    {
      path: "/industry-jobs/:industryName" ,
      element: < IndustryJobsPage/>,
    },
    // {
    //   path: "/applicant-list/:applicantId",
    //   element: < ApplicantList />,
    // },
    // {
    //   path: "/applicant-list/seeker/:jobSeekerId",
    //   element: < ApplicantList />,
    // },
 
    {
      path: "/newemployer",
      element: < JobDashboard/>,
    },
    {
      path: "/id-card",
      element: <DigitalIDCard />,
    },
    {
      path: "/permanentLetter",
      element: <PermanentLetter />,
    },

    {
      path: "/user/:uniqueNumber",
      element: <UserDetails />,
    },
    // {
    //   path: "/employertest/:id",
    //   element: <EmployeePage />,
    // },
    {
      path: "/employer/:id",
      element: <JobDashboard />,
    },
    // {
    //   path: "/profile/:id",
    //   element: <ProfilePage />,
    // },
    {
      path: "/profile/:id",
      element: <JobSeekerDashboard />,
    },
    {
      path: "/jobs",
      element: <JobPage />,
    },

    {path: "/jobs/category/:industry",
       element:<JobsByIndustryPage />},
    {
      path: "/candidate",
      element: <Candidate />,
    },
    {
      path: "/advance_candidate",
      element: <ViewCandidate />,
    },
    {
      path: "/job/:jobId",
      element: <SingleJob />,
    },
    {
      path: "/:applicationId/applicationStatus",
      element: <ApplicantResponse />,
    },
    {
      path: "/:applicantId/applicantProfile/:jobId",
      element: <EmployeeProfile />,
    },
    {
      path: "/job/apply/:jobId",
      element: <ApplyJob />,
    },
    {
      path: "/dashboard",
      element: <Dashboard />,
    },
    {
      path: "/aboutUs",
      element: <AboutUs />,
    },
    {
      path: "/company",
      element: <Company />,
    },
    {
      path: "/contact",
      element: <Company />,
    },
    
    {
      path: "/companies",
      element: <JobEmployerGrid />,
    },
    {
      path: "/verifyToken",
      element: <VerifyToken />,
    },
    {
      path: "/interview/start/:interviewId",
      element: <InterviewPeer />,
    },
    {
      path: "/makeOffer/:employer/:candidate/:application/:index",
      element: <MakeOffer />,
    },
    {
      path: "/Offer/:offerId/:applicationId",
      element: <Offer />,
    },
    {
      path: "/:userId/quickJob",
      element: <Quickjob />,
    },
    // {
    //   path: "/chat",
    //   element: <ChatTwo />,
    // },
    {
      path: "/searchByLocation/:locationId",
      element: <SearchByLocation />,
    },
    {
      path: "/searchByCategory/:categoryName",
      element: <SearchByCategory />,
    },
    {
      path: "/:userId/postJob",
      element: <PostJob />,
    },
    {
      path: "/:jobId/employeeData/:employeeId",
      element: <EmployeeData />,
    },
    {
      path: "/eJA",
      element: <Eja />,
    },
    {
      path: "/:userID/applyforAllowance",
      element: <ApplyForAllowance />,
    },
    {
      path: "/:userID/guarantorForm",
      element: <GuarantorForm />,
    },
    {
      path: "/blacklist",
      element: <Blacklist />,
    },
    {
      path: "/blog",
      element: <Blog />,
    },
    {
      path: "/benefit",
      element: <Benefit />,
    },
    {
      path: "/:employerId/eJAmain",
      element: <EjaDetails />,
    },
    {
      path: "/jobFromEja/:userId",
      element: <JobFromEja />,
    },
    {
      path: "/:userId/notification",
      element: <Notification />,
    },
    {
      path: "/privacy",
      element: <Privacy />,
    },
    {
      path: "/applyjobform",
      element: <ApplyJobForm />,
    },
    {
      path: "/guarantor/:userId",
      element: <GuarantorFormNew />,
    },
    {
      path: "/guarantor-view/:userId",
      element: <GuarantorView />,
    },
    {
      path: "/employmentofferEditor",
      element: <EmploymentOfferEditor />,
    },
    {
      path: "/personaldetails",
      element: <PersonalDetailsForm />,
    },






    {
      path: "/terms",
      element: <TermAndConditions />,
    },
    {
      path: "/:jobId/jobApplicants",
      element: <ApplicantList />,
    },
    {
      path: "/statistics",
      element: <GeneralStats />,
    },
    {
      path: "/interview-tips/:slug",
      element: <InterviewArticlePage />,
    },
  
    {
      path: "/:jobId/applicantResponse",
      element: <ApplicantionStatus />,
    },
    {
      path: "/:userId/createCV",
      element: <TemplateCV />,
    },
    {
      path: "/company/:employerId",
      element: <AboutEmployerPage />,
    },


    {
      path: "/signin",
      element: <SigninPages />,
    },
    {
      path: "/redirectsignin",
      element: <RedirectionSignin />,
    },
    {
      path: "/signup",
      element: <SignupPages />,
    },
    {
      path: "/newPassword/:token/:userId",
      element: <NewPassword />,
    },
    {
      path: "/admindashboard",
      element: <Admin />,
    },
    {
      path: "/adminlogin",
      element: <Login />,
    },
    // {
    //   path: "/adminsignup",
    //   element: <Register />,
    // },
    {
      path: "/jadminlogin",
      element: <JuniorAdminLogin />,
    },
    {
      path: "/jadmindashboard",
      element: <JuniorAdminDashboard />,
    },
      {
      path: "/Aadminlogin",
      element: <AdminAccountantLogin />,
    },
      {
      path: "/accountant1",
      element: <AdminAccountant1 />, 
    },
      {
      path: "/accountant2",
      element: <AdminAccountant2 />,
    },
  
    {
      path: "/jobnotification",
      element: <JobNotificationRegister />,
    },
    {
      path: "/myadminlogin",
      element: <AdminLogin />,
    },
    {
      path: "/myadmindashboard",
      element: <LatestAdminDashboard />,
    },
 
  


    {
      path: "*",
      element: <NotFound />,
    },

 



      {
      path: "/employee/:id",
      element: <EmployeeDetails />,
    },
      {
      path: "/marketer/login",
      element: <MarketerLogin />,
    },
      {
      path: "/marketerdashboard",
      element: <MarketerDashboard />,
    },
      {
      path:"/verify/callback",
      element: <VerifyCallback />,
    },

   





  ]);
  return (
    <>
   {/* {showModal && <PinModal onSubmit={() => setShowModal(false)} />} */}
  <RouterProvider router={router} />
  </>
  )
}

export default App;



///admin details---- email:essential01@gmail.com
///password: essential01











